import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './modules/shared/guards/auth.guard';
import { LayoutContainerComponent } from './layout/layout-container.component';
import {ContactFormComponent} from "./auth/account/contact-form/contact-form.component";
import {LeadFormComponent} from "./auth/account/lead-form/lead-form.component";

const routes: Routes = [

  {
    path: '',
    loadChildren: () => import('./modules/global/global.module').then(m => m.GlobalModule)
  },
  {
    path: 'apps/restaurant/marketing/auto-campaigns/creator',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/app/restaurant/marketing/modules/auto-marketing-campaign/auto-marketing-campaign.module').then(m => m.AutoMarketingCampaignModule)
  },
  {
    path: 'apps',
    component: LayoutContainerComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule),
      },
    ]
  },

  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'kontakt',
    component: ContactFormComponent,
  },
  {
    path: 'partner',
    component: LeadFormComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
